let resumeData = {
  imagebaseurl: "https://ivy555.github.io/",
  name: "Meghann Cunningham",
  role: "DevOps Lead | Platform Engineer | Director of Engineering | AWS, Terraform, CI/CD",
  linkedinId: "",
  skypeid: "",
  roleDescription: "",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/meghann-cunningham-239b5a4b/",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/M3GH4NN",
      className: "fa fa-github",
    },
  ],
  aboutme:
    "I’m a DevOps and platform engineering leader focused on secure cloud infrastructure, CI/CD modernization, infrastructure-as-code, and scalable delivery systems. I’m currently DevOps Lead at Convo Communications, where I focus on migrating on-premises platforms and workloads to AWS using Terraform while supporting high-availability accessibility products. I also serve as Director of Engineering for ReefMind LLC and Miller Mind Solutions Inc., and as an individual contributor supporting Frontera Software’s AWS infrastructure on a contract basis.",
  address: "Minneapolis, MN",
  email: "mc@meghann.dev",
  education: [
    {
      UniversityName: "SUNY Empire State College",
      specialization: "B.S., Computer Science",
      MonthOfPassing: "Graduated April",
      YearOfPassing: "2020",
    },
    {
      UniversityName: "University of Rochester",
      specialization: "B.A., American Sign Language",
      MonthOfPassing: "Graduated December",
      YearOfPassing: "2012",
    },
  ],
  work: [
    {
      CompanyName: "Convo Communications",
      specialization: "DevOps Lead",
      MonthOfLeaving: "Jun",
      YearOfLeaving: "2024 to Present",
      Achievements: [
        "Lead DevOps and platform engineering for accessibility-focused communication products serving Deaf and hard-of-hearing communities.",
        "Migrate on-premises platforms and workloads to AWS using Terraform, building repeatable infrastructure patterns for scalable and reliable production operations.",
        "Design, maintain, and improve CI/CD pipelines and deployment automation with GitHub Actions, Terraform, and AWS services.",
        "Operate and optimize AWS environments across ECS, EKS, IAM, VPC networking, Route53, CloudWatch, CloudTrail, and supporting infrastructure components.",
        "Partner with engineering, product, and operations stakeholders to reduce manual release work, improve observability, and strengthen secure infrastructure practices.",
      ],
    },
    {
      CompanyName: "ReefMind LLC",
      specialization: "Director of Engineering",
      MonthOfLeaving: "May",
      YearOfLeaving: "2026 to Present",
      Achievements: [
        "Lead engineering direction for ReefMind.ai, an AI-enabled reef-aquarium monitoring platform focused on proactive tank health insights and automation.",
        "Own technical architecture decisions across product, data, integrations, infrastructure, and deployment practices for early-stage development.",
        "Translate founder and stakeholder goals into implementation plans, engineering priorities, and maintainable systems that support MVP iteration and growth.",
      ],
    },
    {
      CompanyName: "Miller Mind Solutions Inc.",
      specialization: "Director of Engineering",
      MonthOfLeaving: "May",
      YearOfLeaving: "2026 to Present",
      Achievements: [
        "Founding engineering leader responsible for technical strategy, solution architecture, and delivery practices across client and internal product initiatives.",
        "Build reusable automation patterns and AI-enabled workflows that help small teams improve operations while managing infrastructure, data, and delivery risk.",
        "Collaborate with business and operations leadership on roadmaps, implementation priorities, and scalable engineering processes.",
      ],
    },
    {
      CompanyName: "Frontera Software",
      specialization: "DevOps Engineer (Contract)",
      MonthOfLeaving: "Sep",
      YearOfLeaving: "2024 to Present",
      Achievements: [
        "Serve as an individual contributor supporting AWS infrastructure for Frontera Software, including operational fixes, configuration updates, and reliability improvements.",
      ],
    },
    {
      CompanyName: "EITR Technologies, LLC",
      specialization: "Platform Engineer",
      MonthOfLeaving: "Dec",
      YearOfLeaving: "2022 to May 2024",
      Achievements: [
        "Collaborated with executive leadership on AWS automation solutions, improving operational efficiency for customer projects and internal deployment tooling.",
        "Optimized GitHub Actions, GitLab CI pipelines, and AWS CloudFormation templates to improve reliability and repeatability of infrastructure deployments.",
        "Contributed to SaltStack open-source development, supporting tool functionality and community engagement.",
      ],
    },
    {
      CompanyName: "Applied Insight (formerly Stratus Solutions)",
      specialization: "Team Lead | DevOps Engineer",
      MonthOfLeaving: "Sep",
      YearOfLeaving: "2019 to Dec 2022",
      Achievements: [
        "Developed and managed secure AWS infrastructure for federal government projects with strict security, compliance, and reliability requirements.",
        "Led automation efforts across AWS environments and GitLab pipelines, improving deployment efficiency and operational consistency.",
        "Promoted to Game Development Team Lead in 2022, overseeing AWS infrastructure and website development for a compliance-sensitive game project.",
        "Contributed to game design and development using the Godot engine while guiding front-end, back-end, and deployment improvements.",
      ],
    },
    {
      CompanyName: "Stratus Solutions",
      specialization: "DevOps Engineer Intern",
      MonthOfLeaving: "Jun",
      YearOfLeaving: "2019 to Aug 2019",
      Achievements: [
        "Implemented AWS networking automation tools for a classified platform in a secure environment.",
        "Presented the internship project company-wide, communicating technical concepts and automation impact to a broad audience.",
      ],
    },
    {
      CompanyName: "Sign Language Connection, Inc.",
      specialization: "Scheduling Coordinator Supervisor",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2013 to Sep 2019",
      Achievements: [
        "Supervised scheduling operations, interpreter coordination, customer support, and internal database workflows for accessibility-focused services.",
        "Supported business operations and compliance needs, including ADA and HIPAA-aligned processes.",
      ],
    },
  ],
  skills: [
    {
      skillname:
        "Cloud & Infrastructure: AWS, Azure, Terraform, CloudFormation, AWS CDK, ECS, EKS, Docker, IAM, VPC, Route53, CloudWatch, CloudTrail",
    },
    {
      skillname:
        "DevOps & Delivery: GitHub Actions, GitLab CI, CI/CD pipeline design, infrastructure automation, DevSecOps, observability, monitoring, alerting",
    },
    {
      skillname: "Languages & Scripting: Python, Bash, JavaScript, TypeScript, Golang, PowerShell",
    },
    {
      skillname:
        "Leadership & Operations: engineering roadmaps, cross-functional delivery, vendor/client collaboration, compliance-minded systems, team enablement",
    },
  ],
  portfolio: [
    {
      name: "HypeTrain",
      description:
        "I created a Python program that uses HTTP Requests and APIs to grab data from a public video game database in order to create a list of upcoming video game release dates. The user creates a list by searching for a game that they would like to keep track of and adding that game to their Watch List. The list can be modified at any time by the user. The user can also click an auto-update button that runs a function that will go through their watch list, remove any game whose release date has passed, and update any release dates that have changed. I am also working on transforming this program into a website (MERN Stack).",
      imgurl: "images/dualsense.jpg",
      url: "https://github.com/M3GH4NN/hypetrain",
    },
    {
      name: "Custom Smart Home Skills",
      description:
        "I have created several smart home skills to help deaf family members. One example is that I linked my Ring doorbell to my Echo devices and then added custom logic to flash the smart lights in the house if someone rings the doorbell. The flashing smart lights will alert my mother that someone is at the door.",
      imgurl: "images/smarthome.jpg",
    },
    {
      name: "Smart Monitor",
      description:
        "I created a smart monitor using my Raspberry Pi and a spare monitor. The monitor displays my calendar for the next four weeks, the current weather, the forecast for the rest of the week, and has a rotating background that uses images from a Google Photos smart album of my dogs.",
      imgurl: "images/20220418_090624.jpg",
    },
  ],
};

export default resumeData;
